export const xvs_addr = '0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63';
export const xvs_vault = ['0x051100480289e704d20e9DB4804837068f3f9204', '0xa0c958ca0ffa25253de0a23f98ad3062f3987073'];
export const treasury = '0xf322942f644a996a617bd29c16bd7d231d9f35e9';
export const vai_addr = '0x4bd17003473389a42daf6a0a729f6fdb328bbbd7';
export const balancesLensAddr = '0x7fd7E938d575Fe8ccF72ED65a82142D154C170Af';